module.exports = __webpack_public_path__ + "static/media/snappy.e7fbfa26.svg";